module.exports = __webpack_public_path__ + "img/banner_icon1.46d6fa58.png";